import React from "react";
import t from "./translate";

export default function AdminBreadcrumbs({ items = [] }) {
  if (!items.length) {
    return null;
  }

  return (
    <nav aria-label={t("shared.admin_breadcrumbs.aria_label")} className="px-5 pt-5 lg:px-8 lg:pt-6">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-slate-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={`${item.label}-${index}`}>
              {index > 0 ? <li className="text-slate-300">/</li> : null}
              <li>
                {item.href && !isLast ? (
                  <a href={item.href} className="font-medium text-slate-500 transition hover:text-brand-700">
                    {item.label}
                  </a>
                ) : (
                  <span className={isLast ? "font-semibold text-slate-900" : "font-medium text-slate-500"}>
                    {item.label}
                  </span>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
